export default __webpack_public_path__ + "static/media/alert-circle-orange.fc4c0bc7.svg";